<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Select</h1>
			</div>
		</div>
    <div id="content">
      <div class="types">
        <h2>Types</h2>
        <h3>Single</h3>
        <div class="right">
          <mt-select name="default-select" :options="options" placeholder="Select" label="Field label"/>
        </div>
        <h3>Disabled</h3>
        <div class="right">
          <mt-select name="default-select" :options="options" placeholder="Select" label="Field label" :disabled="true"/>
        </div>
        <h3>Clearable single</h3>
        <div class="right">
          <mt-select name="default-select" :options="options" placeholder="Select" label="Field label" clearble/>
        </div>
        <h3>Multiple</h3>
        <div class="right">
          <mt-select name="default-select" :options="options" placeholder="Select" label="Field label" clearble/>
        </div>
        <h3>Auto filtering</h3>
        <div class="right">
          <mt-select name="default-select" :options="options2" placeholder="Select" label="Field label" autoFilter/>
        </div>
      </div>
      <br />
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [],
  components: {

  },
  data(){
    return {
      options: [
        {
          value: 'Option1',
          label: 'Option1'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      options2: ["Alabama", "Alaska", "Arizona",
      "Arkansas", "California", "Colorado",
      "Connecticut", "Delaware", "Florida",
      "Georgia", "Hawaii", "Idaho", "Illinois",
      "Indiana", "Iowa", "Kansas", "Kentucky",
      "Louisiana", "Maine", "Maryland",
      "Massachusetts", "Michigan", "Minnesota",
      "Mississippi", "Missouri", "Montana",
      "Nebraska", "Nevada", "New Hampshire",
      "New Jersey", "New Mexico", "New York",
      "North Carolina", "North Dakota", "Ohio",
      "Oklahoma", "Oregon", "Pennsylvania",
      "Rhode Island", "South Carolina",
      "South Dakota", "Tennessee", "Texas",
      "Utah", "Vermont", "Virginia",
      "Washington", "West Virginia", "Wisconsin",
      "Wyoming"]
    }
  },
  computed: {

  },

  methods: {

  },


}
</script>
<style lang="scss">
p {
  line-height: 1.57;
  margin: 0;
}
h3 { font-size: 16px; }
.types .right {
  width: 30%;
  padding: 2%;
  float: right;
  height: 94px;
  .button-wrap{
    padding-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// Select.vue?dde26624